/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Chat-content empty state — Figma node 3281:98498. Rendered centred
// in `content-main` when no conversation is selected.
//
// Layout per Figma (text-only — *no logomark*):
//   "Ping for Mac"               Lato 700 20/28 text-muted
//   "Your chats are " + link     Lato 400 16/22.4 text-muted + Lato 400 14/19.6 accent-brand

import { Pressable, Text, View } from 'react-native';
import type { ChatEmptyStateProps } from './ChatRoom.types';

export function ChatEmptyState(props: ChatEmptyStateProps): JSX.Element {
	const { productName = 'Ping for Web', onEncryptionInfoPress } = props;

	return (
		<View className="flex-1 flex flex-col items-center justify-center gap-sm px-xl bg-light-surface-panel dark:bg-dark-surface-panel">
			<Text className="font-sans font-bold text-[20px] leading-[28px] text-light-text-muted dark:text-dark-text-muted text-center">
				{productName}
			</Text>
			<View className="flex flex-row items-center justify-center gap-[2px]">
				<Text className="font-sans font-normal text-[16px] leading-[22px] text-light-text-muted dark:text-dark-text-muted text-center">
					Your chats are{' '}
				</Text>
				{onEncryptionInfoPress ? (
					<Pressable
						accessibilityRole="link"
						accessibilityLabel="Learn more about end-to-end encryption"
						onPress={onEncryptionInfoPress}
					>
						<Text className="font-sans font-normal text-[14px] leading-[20px] text-light-accent-brand dark:text-dark-accent-brand">
							end-to-end encrypted
						</Text>
					</Pressable>
				) : (
					<Text className="font-sans font-normal text-[14px] leading-[20px] text-light-accent-brand dark:text-dark-accent-brand">
						end-to-end encrypted
					</Text>
				)}
			</View>
		</View>
	);
}
